



export const all_mappings = [
  {
    domain: "http://localhost:5050",
    mapped_domain: "http://app.localhost:3001",
  },
  {
    domain: "https://arxena.com",
    mapped_domain: "https://app.arxena.com",
  },
  {
    domain: "https://www.arxena.com",
    mapped_domain: "https://app.arxena.com",
  },
  {
    domain: "https://services.arxena.com",
    mapped_domain: "https://app.arxena.com",
  },
];



export const twenty_server_mappings = [
  {
    domain: "http://localhost:5050",
    mapped_domain: "http://localhost:3000",
  },
  {
    domain: "https://arxena.com",
    mapped_domain: "https://app.arxena.com",
  },
  {
    domain: "https://www.arxena.com",
    mapped_domain: "https://app.arxena.com",
  },
  {
    domain: "https://services.arxena.com",
    mapped_domain: "https://app.arxena.com",
  },
];



class PageContents {
  async setTopBar() {
    var extension_status = await new CheckChromeExtension().getExtensionStatus();
    // extension_status = false;
    console.log("Extension status::", extension_status);
    if (!extension_status) {
      document.getElementById("topbar_advert").style.display = "table";
    } else {
      document.getElementById("topbar_advert").style.display = "none";
    }
  }

  closeTopBar() {
    console.log("This is the close");
    document.getElementById("topbar_advert").style.display = "none";
    try {
      document.getElementById("myDiagramDiv").style.height = ($(window).height() * (1 - 0.21)).toString();
    } catch {}
  }

  clearHeaderElement() {
    console.log("Called clear header");
    try {
      // document.getElementById("left_arrow_panel").innerHTML = ''
      document.getElementById("current_account_name").innerHTML = "";
      document.getElementById("arrow_panel").innerHTML = "";
      document.getElementById("contact_card_linkedin_link_org_chart_header").innerHTML = "";
      document.getElementById("linkedin_icon_header").innerHTML = "";
      document.getElementById("functional_dropdown_container").innerHTML = "";
      document.getElementById("geo_dropdown_container").innerHTML = "";
      var metaRowEls = document.querySelectorAll("[id='org_chart_company_meta_row']");
      for (var i = 0; i < metaRowEls.length; i++) {
        metaRowEls[i].innerHTML = "";
        metaRowEls[i].style.display = "none";
      }
      var websiteLinkEls = document.querySelectorAll("[id='org_chart_company_website_link']");
      for (var j = 0; j < websiteLinkEls.length; j++) {
        websiteLinkEls[j].href = "#";
        websiteLinkEls[j].style.display = "none";
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  replaceTopBarwhenLoggedOut() {
    document.getElementById("elements_loggedin_logged_out").innerHTML = document.getElementById("loggedout_elements").innerHTML;
    document.getElementById("elements_loggedin_logged_out_mobi").innerHTML = document.getElementById("loggedout_elements_mobi").innerHTML;
  }

  replaceTopBarandHeaderElementwhenLoggedOut() {
    this.replaceTopBarwhenLoggedOut();
    // Do not clear header so org chart company info (name, website, LinkedIn, industry, employees) remains visible in logged-out mode
  }

  logIn() {
    console.log("logIn FUNCTION CALLED");
    const twenty_front_base_url = all_mappings.find((mapping) => mapping.domain === base_url)?.mapped_domain;
    window.location.href = twenty_front_base_url + "/welcome";

    // if (sessionStorage["email"] == "" || sessionStorage["password"] == "") {
    //   console.log("email and password are in somewhat in the session ");
    //   document.getElementById("login_error").innerHTML = '<br><span style="color:red">Please fill in all the fields :-)</span>';
    //   document.getElementById("login_error_mobi").innerHTML = '<br><span style="color:red">Please fill in all the fields :-)</span>';
    // } else {
    //   var params_obj = updateParamsObj();
    //   console.log("email and password are not the session");
    //   var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/>';
    //   document.getElementById("login_error").innerHTML = loader;
    //   document.getElementById("login_error_mobi").innerHTML = loader;
    //   $.ajax({
    //     url: "/auth/signin",
    //     type: "POST",
    //     data: {
    //       email: sessionStorage["email"],
    //       password: sessionStorage["password"],
    //       params: params_obj,
    //       visitor_fp: sessionStorage["visitor_fp"],
    //     },
    //     error: function (xhr, status) {
    //       var error_status = xhr.status;
    //       if (error_status == 599) {
    //         new PageContents().tokenExpireAction();
    //       }
    //     },
    //   }).done(function (data) {
    //     console.log("AJAX to hit auth/signin ");
    //     console.log("This is the AJAX response ", data);
    //     console.log("token got ehre");
    //     console.log(data);
    //     console.log(data.status);
    //     if (data.status == "login_ok") {
    //       console.log("login was okay, so now onwards?");
    //       Cookies.set("auth_token", data.auth_token, { expires: 7, path: "/" });
    //       Cookies.set("visitor_fp", sessionStorage["visitor_fp"], {
    //         expires: 7,
    //         path: "/",
    //       });

    //       // $.cookie('auth_token',data.auth_token);
    //       // document.cookie = 'auth_token='+data.auth_token
    //       localStorage["email"] = data.user["email"];
    //       localStorage["user_id"] = data.user["_id"];
    //       localStorage["user"] = JSON.stringify(data.user);
    //       new PageContents().setLogonStatus();
    //       console.log("Login user id setup");
    //       console.log(localStorage["user_id"]);
    //       // now purify the sessionStorage not to expose the password
    //       sessionStorage["username"] = "";
    //       sessionStorage["password"] = "";
    //       var use_case = data.user.use_case;
    //       sessionStorage["use_case"] = data.user["use_case"];

    //       new PageContents().setMixPanelAliasUser();
    //       new PageContents().setMixPanelIdentifyUser();
    //       // drift_append_email()
    //       // new PageContents().changePage("/org-chart");
    //       new PageContents().changePage("/lists");

    //       // extension setup
    //       console.log("before CheckChromeExtension");
    //       let user = data.user;
    //       if (!!user && !user?.chrome_extension_id) {
    //         console.log("cond true CheckChromeExtension");
    //         new CheckChromeExtension().sendMessageToContentFromOrgChart(data.auth_token);
    //       }
    //       console.log("after CheckChromeExtension");
    //     } else if (data.status == "no_email") {
    //       console.log("User not registerd with this email");
    //       new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
    //       document.getElementById("login_error").innerHTML = '<br><span style="color:red">This user has not been registered.</span>';
    //       document.getElementById("login_error_mobi").innerHTML = '<br><span style="color:red">This user has not been registered.</span>';
    //     } else if (data.status == "visitor_fp_exists") {
    //       console.log("Visitor FP Exists");
    //       new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
    //       document.getElementById("login_error").innerHTML = '<br><span style="color:red">Your account is not configured to open on this computer/ browser.</span>';
    //       document.getElementById("login_error_mobi").innerHTML = '<br><span style="color:red">Your account is not configured to open on this computer/ browser.</span>';
    //     } else {
    //       new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
    //       console.log("Login is not okay");
    //       document.getElementById("login_error").innerHTML = '<br><span style="color:red">Invalid email or password</span>';
    //       document.getElementById("login_error_mobi").innerHTML = '<br><span style="color:red">Invalid email or password</span>';
    //     }
    //   });
    // }
  }

  logOut() {
    console.log("logOut FUNCTION CALLED");
    let data = { type: "logout" };
    window.postMessage(data, base_url);
    // localStorage['email'] = '';
    // localStorage['user_id'] = '';
    // localStorage['user'] = '{}';
    new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
    // sessionStorage['logon_status'] = 'false';
    // setLogonStatus();
    var allCookies = document.cookie.split(";");
    // The "expire" attribute of every cookie is
    // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
    for (var i = 0; i < allCookies.length; i++) document.cookie = allCookies[i] + "=;expires=" + new Date(0).toUTCString();
    new PageContents().changePage("/#");
    document.cookie = "auth_token" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = "visitor_fp" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
  tokenExpireAction() {
    $(".modal").modal("hide");
    console.log("token Expire Action FUNCTION CALLED");
    let data = { type: "logout" };
    window.postMessage(data, base_url);
    new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
    var allCookies = document.cookie.split(";");
    for (var i = 0; i < allCookies.length; i++) document.cookie = allCookies[i] + "=;expires=" + new Date(0).toUTCString();
    document.cookie = "auth_token" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = "visitor_fp" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    new PageContents().changePage("/login");
  }

  signUp() {
    console.log("signUp FUNCTION CALLED");
    const twenty_front_base_url = all_mappings.find((mapping) => mapping.domain === base_url)?.mapped_domain;
    window.location.href = twenty_front_base_url + "/welcome";
    // if (sessionStorage['full_name']=='' || sessionStorage['email']=='' || sessionStorage['password']=='' || sessionStorage['phone']=='' || sessionStorage['use_case']=='') {
    // if (sessionStorage["full_name"] == "" || sessionStorage["email"] == "" || sessionStorage["password"] == "" || sessionStorage["phone"] == "") {
    //   document.getElementById("signup_error").innerHTML = '<br><span style="color:red">Please fill in all the fields :-)</span>';
    //   document.getElementById("signup_error_mobi").innerHTML = '<br><span style="color:red">Please fill in all the fields :-)</span>';
    // } else if (["gmail", "hotmail", "yahoo", "msn"].some((v) => sessionStorage["email"].includes(v))) {
    //   document.getElementById("signup_error").innerHTML = '<br><span style="color:red">Please use a valid business email :-)</span>';
    //   document.getElementById("signup_error_mobi").innerHTML = '<br><span style="color:red">Please use a valid business email :-)</span>';
    // } else {
    //   try {
    //     // $('sign_up_modal').modal('hide');
    //     $(sign_up_modal).modal("hide");
    //     document.getElementById("signup_error").innerHTML = "";
    //     document.getElementById("signup_error_mobi").innerHTML = "";
    //     document.getElementById("signup_form_content").innerHTML =
    //       '<span style="font-size:18pt;font-weight: 500;">Creating your account...</span><br><br><br><div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br></div>';
    //     document.getElementById("signup_form_content_mobi").innerHTML =
    //       '<span style="font-size:18pt;font-weight: 500;">Creating your account...</span><br><br><br><div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br></div>';
    //   } catch (error) {
    //     console.log("Error:", error);
    //   }

    //   var params_obj = updateParamsObj();

    //   var session_storage_visitor_fp = sessionStorage["visitor_fp"] || "";
    //   // session_storage_visitor_fp = ''
    //   // if (((session_storage_visitor_fp.length!=20))&(typeof(session_storage_visitor_fp)!='string')){
    //   //     new VisitorFp().setupVisitorFP()
    //   // }

    //   // session_storage_visitor_fp = sessionStorage['visitor_fp']

    //   // if ((((session_storage_visitor_fp.length!=20))&(typeof(session_storage_visitor_fp)!='string'))){
    //   //     location.reload()

    //   // }

    //   // if ((((session_storage_visitor_fp.length!=20))&(typeof(session_storage_visitor_fp)!='string'))){
    //   //     document.getElementById("signup_error").innerHTML = '<br><span style="color:red">Sorry, there seems to be a problem with your browser in accessing this account: '+data['email']+' can be used on this computer. To change, please contact us at accounts@arxena.com :-)</span>'
    //   //     document.getElementById("signup_error_mobi").innerHTML = '<br><span style="color:red">Only the account with email address: '+data['email']+' can be used on this computer. To change, please contact us at accounts@arxena.com :-)</span>'
    //   // }

    //   $.ajax({
    //     url: "/auth/signup",
    //     type: "POST",
    //     data: {
    //       full_name: sessionStorage["full_name"],
    //       email: sessionStorage["email"],
    //       phone: sessionStorage["phone"],
    //       use_case: sessionStorage["use_case"],
    //       password: sessionStorage["password"],
    //       referrer_id: sessionStorage["referrer_id"],
    //       visitor_fp: session_storage_visitor_fp,
    //       ipinfo_resp: sessionStorage["ipinfo_resp"],
    //       geo_country_selected: sessionStorage["geo_country_selected"],
    //     },
    //     error: function (xhr, status) {
    //       var error_status = xhr.status;
    //       if (error_status == 599) {
    //         new PageContents().tokenExpireAction();
    //       }
    //     },
    //   }).done(function (data) {
    //     if (typeof data != "string") {
    //       console.log("AJAX to hit /auth/signup ");
    //       console.log("This is the AJAX response ", data);
    //       if (data.status == "user_created") {
    //         Cookies.set("auth_token", data.auth_token, {
    //           expires: 7,
    //           path: "/",
    //         });
    //         Cookies.set("visitor_fp", sessionStorage["visitor_fp"], {
    //           expires: 7,
    //           path: "/",
    //         });
    //         localStorage["email"] = data.user["email"];
    //         localStorage["user_id"] = data.user["_id"];
    //         // localStorage['user'] = data.user['_id']
    //         sessionStorage["password"] = "";
    //         localStorage["user"] = JSON.stringify(data.user);
    //         sessionStorage["walkthrough"] = "yes";
    //         new PageContents().setLogonStatus();

    //         new PageContents().setMixPanelAliasUser();
    //         new PageContents().setMixPanelIdentifyUser();
    //         // new PageContents().changePage("/org-chart");
    //         new PageContents().changePage("/lists");

    //         // extension setup
    //         console.log("before CheckChromeExtension");
    //         let user = data.user;
    //         if (!!user && !user?.chrome_extension_id) {
    //           console.log("cond true CheckChromeExtension");
    //           new CheckChromeExtension().sendMessageToContentFromOrgChart(data.auth_token);
    //         }
    //         console.log("after CheckChromeExtension");
    //       } else {
    //         document.getElementById("all_content").innerHTML = document.getElementById("new_signup_page").innerHTML;
    //         if (data["status"] == "visitor_fp_exists") {
    //           document.getElementById("signup_error").innerHTML = '<br><span style="color:red">Only the account with email address: ' + data["email"] + " can be used on this computer. To change, please contact us at accounts@arxena.com :-)</span>";
    //           document.getElementById("signup_error_mobi").innerHTML =
    //             '<br><span style="color:red">Only the account with email address: ' + data["email"] + " can be used on this computer. To change, please contact us at accounts@arxena.com :-)</span>";
    //           setTimeout("new UtilityFunctions().clearStoragesandReload()", 2000);
    //         } else {
    //           if (data["status"] == "user_already_registered_with_email") {
    //             document.getElementById("signup_error").innerHTML = '<br><span style="color:red">This email is already registered. Log in instead :-)</span>';
    //             document.getElementById("signup_error_mobi").innerHTML = '<br><span style="color:red">This email is already registered. Log in instead :-)</span>';
    //             setTimeout("new UtilityFunctions().clearStoragesandReload()", 2000);
    //           } else if (data["status"] == "user_already_registered_with_phone") {
    //             document.getElementById("signup_error").innerHTML = '<br><span style="color:red">This phone has already been registered. Log in instead :-)</span>';
    //             document.getElementById("signup_error_mobi").innerHTML = '<br><span style="color:red">This phone has already been registered. Log in instead :-)</span>';
    //             setTimeout("new UtilityFunctions().clearStoragesandReload()", 2000);
    //           }
    //         }
    //         // if enter is pressed, then submit the form
    //         $(".enter_click").keydown(function (event) {
    //           var keyCode = event.keyCode ? event.keyCode : event.which;
    //           console.log(keyCode);
    //           if (keyCode == 13) {
    //             new PageContents().signUp();
    //           }
    //         });
    //         $("#signup_button_desktop").attr("tabindex", -1).focus();
    //       }
    //     } else {
    //       new PageContents().changePage("/#");
    //     }
    //   });
    // }
  }

  sendResetLink() {
    console.log("sendResetLink FUNCTION CALLED");
    if (sessionStorage["email"] == "") {
      document.getElementById("password_reset_error").innerHTML = '<br><span style="color:red">Please provide a valid email address</span>';
      document.getElementById("password_reset_error_mobi").innerHTML = '<br><span style="color:red">Please provide a valid email address</span>';
    } else {
      document.getElementById("password_reset_error").innerHTML = "";
      document.getElementById("password_reset_error_mobi").innerHTML = "";
      document.getElementById("reset_password_form_content").innerHTML =
        '<span style="font-size:18pt;font-weight: 500;">Finding your account...</span><br><br><br><div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br></div>';
      document.getElementById("reset_password_form_content_mobi").innerHTML =
        '<span style="font-size:18pt;font-weight: 500;">Finding your account...</span><br><br><br><div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br></div>';
      $.ajax({
        url: "/forgot_password",
        type: "POST",
        data: { email: sessionStorage["email"] },
        error: function (xhr, status) {
          var error_status = xhr.status;
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
        },
      }).done(function (data) {
        console.log("AJAX to hit reset_password ");
        console.log("This is the AJAX response ", data);
        console.log("This is the status response ", data.status);

        if (data.status == "reset_mail_sent") {
          document.getElementById("reset_password_form_content").innerHTML = '<span style="font-size:18pt;font-weight: 500;">An email to reset your password has just been sent to your inbox!</span>';
          document.getElementById("reset_password_form_content_mobi").innerHTML = '<span style="font-size:18pt;font-weight: 500;">An email to reset your password has just been sent to your inbox!</span>';
        } else {
          document.getElementById("all_content").innerHTML = document.getElementById("password_reset_page").innerHTML;
          document.getElementById("password_reset_error").innerHTML = '<br><span style="color:red">There is no user account matching with the email provided</span>';
          document.getElementById("password_reset_error_mobi").innerHTML = '<br><span style="color:red">There is no user account matching with the email provided</span>';
          new UtilityFunctions().clearStoragesandReload();
        }
      });
    }
  }

  setLogonStatus() {
    console.log("Called to set logon status!");
    var hasEmail = "email" in localStorage && localStorage["email"] && localStorage["email"].length > 0;
    var hasAuthToken =
      typeof Cookies !== "undefined" && Cookies.get("auth_token");
    if (hasEmail || hasAuthToken) {
      sessionStorage["logon"] = "true";
      console.log("Setting logon status to TRUE");
    } else {
      sessionStorage["logon"] = "false";
      console.log("Setting logon status to FALSE");
    }
  }

  setMixPanelIdentifyUser() {
    if (localStorage["user"]) {
      mixpanel.identify(JSON.parse(localStorage["user"])["email"]);
    }
  }

  setMixPanelAliasUser() {
    mixpanel.alias(JSON.parse(localStorage["user"])["email"]);
  }

  changePage(extension) {
    console.log("changePage FUNCTION CALLED");
    console.log("Extension being called==", extension);
    console.log("This is the localstorage USER ID::", localStorage["user_id"]);
    // save current path - basically where I'm now
    try {
      document.getElementById("right_panel_org_chart_people_companies").style.display = "none";
    } catch (error) {}
    try {
      var pages_list = sessionStorage["navigation_history"].split(",");
      var current_page = pages_list[pages_list.length - 1];
      console.log("Current page is ::", current_page);
    } catch (error) {
      console.log("Error:", error);
    }
    sessionStorage["navigation_history"] = sessionStorage["navigation_history"] + "," + extension;
    console.log("This is navigation hisotry created by adding extensions to session storage", sessionStorage["navigation_history"]);
    // understand which page to load based on the extension
    // first, separate the parameters, which we conventionally separate with "#"
    // the first element of the list will be the page (e.g. /pool/mamma), and the following elements, if present, are the parameters
    var routing_list = extension.split("&");
    // check if there are parameters or not
    if (routing_list.length == 1) {
      // in this case, there are no parameters, just the page
      var new_page = routing_list[0];
      var parameters = [];
    } else {
      // in this case, there are both the page and some parameters
      var new_page = routing_list[0];
      var parameters = [];
    }

    // now that we know which page we need to go next, load this page
    // first, let's adapt the url in the browser bar
    console.log("This is new page created in change page function froum routing list using paarams", new_page);
    // then, load the right page
    if (new_page == "/login") {
      console.log("got to login");
      window.history.pushState(null, null, extension);
      const twenty_front_base_url = all_mappings.find((mapping) => mapping.domain === base_url)?.mapped_domain;
      window.location.href = twenty_front_base_url + "/welcome";
      console.log("window.location.href", window.location.href);
      console.log("base_url", base_url);
      console.log("twenty_server_mappings", twenty_server_mappings);
      console.log("twenty_front_base_url", twenty_front_base_url);



      // new Pages().loginPage();
      mixpanel.track("loginPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/pricing") {
      console.log("got to pricing");
      window.history.pushState(null, null, extension);
      new Pages().pricingPage();
      mixpanel.track("pricingPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/signup") {
      window.history.pushState(null, null, extension);

      const twenty_front_base_url = all_mappings.find((mapping) => mapping.domain === base_url)?.mapped_domain;
      window.location.href = twenty_front_base_url + "/welcome";
      // new Pages().signupPage();
      mixpanel.track("signupPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/password_reset_link") {
      window.history.pushState(null, null, extension + "/" + sessionStorage["reset_token_id"]);
      new PasswordReset().passwordResetLinkPage();
      mixpanel.track("loginPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/password_reset") {
      window.history.pushState(null, null, extension);
      passwordResetPage();
      mixpanel.track("passwordResetPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/org-chart") {
      console.log("Got here with new page is equal to org chart page");
      console.log(sessionStorage["query"]);
      // if (typeof(JSON.parse(sessionStorage['query'])['company_id']['name']) != "undefined"){
      if ((typeof sessionStorage["query"] != "undefined") & (typeof JSON.parse(sessionStorage["query"])["company_id"]["name"] != "undefined")) {
        console.log("Raise org chart End Point");
        new Pages().searchPage();
        window.history.pushState(null, null, extension + "/" + JSON.parse(sessionStorage["query"])["company_id"]["name"]);
        mixpanel.track("searchPageOrgCharts", {
          source: window.location.href,
          current_focus: sessionStorage["current_focus"],
        });
      } else {
        window.history.pushState(null, null, extension + "/");
        new Pages().searchPage();
        mixpanel.track("searchPageBlank", {
          source: window.location.href,
          current_focus: sessionStorage["current_focus"],
        });
      }
    } else if (new_page == "/dashboard") {
      window.history.pushState(null, null, "/dashboard");
      document.title = "Arxena's Org Charts (Global) - Dashboard";
      new Pages().dashboardPage();
      mixpanel.track("dashboardPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/tables") {
      window.history.pushState(null, null, "/tables");
      document.title = "Arxena's Org Charts (Global) - Dashboard";
      new Pages().tablesPage();
      mixpanel.track("tablesPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/lists") {
      window.history.pushState(null, null, "/lists");
      document.title = "Arxena's Org Charts (Global) - Dashboard";
      new Pages().switchAllContentToSearchPage();
      new Pages().jobsPage();
      mixpanel.track("jobsPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/liststable") {
      window.history.pushState(null, null, "/liststable");
      document.title = "Arxena's Org Charts (Global) - Dashboard";
      new Pages().listsPage();
      mixpanel.track("liststable", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/eula") {
      window.history.pushState(null, null, extension);
      document.title = "Arxena's Org Charts (Global) - EULA";
      new Pages().eulaPage();
      mixpanel.track("eulaPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/api") {
      window.history.pushState(null, null, extension);
      document.title = "Arxena's Org Charts (Global) - API";
      new Pages().apiPage();
      mixpanel.track("apiPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/home") {
      window.history.pushState(null, null, extension);
      document.title = "Arxena's Org Charts (Global) - API";
      new Pages().landingPage();
      mixpanel.track("home", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/privacy") {
      window.history.pushState(null, null, extension);
      document.title = "Arxena's Org Charts (Global) - Privacy";
      new Pages().privacyPage();
      mixpanel.track("privacyPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    } else if (new_page == "/#") {
      console.log("Going to load front page");
      window.history.pushState(null, null, extension);
      document.title = "Arxena's Org Charts (Global) - Arxena";
      new Pages().frontPage();
      new ProcessNodesStates().resetSessionStorageforDropdowns();
      mixpanel.track("frontPage", {
        source: window.location.href,
        current_focus: sessionStorage["current_focus"],
      });
    }
    return false;
  }
}

class Modals {
  addNewJobModal() {
    $(create_new_job_modal).modal("show");
  }

  addBlockModalEditStructure(d) {
    console.log("addBlockModalEditStructure FUNCTION CALLED");

    temp_diagram = d;
    sessionStorage["new_block_headline"] = "";
    $("#new_block_headline").val("");

    $(add_new_block_modal_edit_structure).modal("show");
  }

  seeMoreModal(key) {
    console.log("new Modals().seeMoreModal FUNCTION CALLED");

    var current_chart_data = myDiagram.model.nodeDataArray;

    // identify the current block
    for (var i = 0, len = current_chart_data.length; i < len; i++) {
      if (current_chart_data[i]["key"] == key) {
        var block = current_chart_data[i];
      }
    }
    console.log(block);

    var rows = "";
    for (var j = 0; j < 100; j++) {
      if ((block !== undefined) & (block["name_" + j.toString()] != undefined)) {
        // console.log(block)
        // console.log(block['candidates'])
        // console.log(block['candidates'][j])
        // console.log(j)
        if (block["candidates"][j] != undefined) {
          var new_row_elem = document.getElementById("see_more_person_row_element").innerHTML;
          // console.log("This is jj::", j,"and this is the type of id::", typeof(block['id_' + j.toString()]))
          if (typeof block["id_" + j.toString()] == "number") {
            var person_id = j;
          } else if (block["id_" + j.toString()] == "0") {
            var person_id = j.toString();
          } else {
            var person_id = block["id_" + j.toString()];
          }

          var new_row = new_row_elem
            .replaceAll(/{name}/g, block["name_" + j.toString()] || "")
            .replaceAll(/{person_id}/g, person_id || "")
            .replaceAll(/{title}/g, block["title_" + j.toString()] || "")
            // .replace(/{image}/g, block['image_' + j.toString()])
            .replaceAll(/{image}/g, "static/img/blank-profile-picture-png-transparent.png" || "")
            .replaceAll(/{linkedin_url}/g, "window.open('" + block["candidates"][j]["std_linkedin_url"] + "', '_blank');" || "")
            .replaceAll(/{facebook_url}/g, "window.open('https://" + block["candidates"][j]["facebook_url"] ? block["candidates"][j]["facebook_url"] : "" + "', '_blank');" || "")
            .replaceAll(/{twitter_url}/g, "window.open('https://" + block["candidates"][j]["twitter_url"] ? block["candidates"][j]["twitter_url"] : "" + "', '_blank');" || "");

          // .replace(/{linkedin_url}/g, "new UtilityFunctions().getLinkedinUrl('"+ block['name_' + j.toString()] +"', '"+ block['title_' + j.toString()] +"', '"+ block['std_linkedin_url' + j.toString()] +"', '"+ block['image_' + j.toString()]+"')")
          // .replaceAll(/{linkedin_url}/g, "window.open('"+ typeof(block['candidates'][j]['std_linkedin_url'])  ? block['candidates'][j]['std_linkedin_url'] : "" +"', '_blank');")
          // .replaceAll(/{facebook_url}/g, "window.open('"+typeof(block['candidates'][j]['facebook_url']) != 'undefined' ? block['candidates'][j]['facebook_url'] :"" +"', '_blank');")
          // .replaceAll(/{twitter_url}/g, "window.open('"+typeof(block['candidates'][j]['twitter_url']) != 'undefined' ? block['candidates'][j]['twitter_url'] : "" +"', '_blank');")
          rows = rows + new_row;
          // console.log(rows);
        }
      } else {
        // console.log("Blocks looks like undefined!!!!")
      }
    }

    document.getElementById("people_rows").innerHTML = rows;

    for (var j = 0; j < 100; j++) {
      if (typeof block["id_" + j.toString()] == "number") {
        var person_id = j;
      } else if (block["id_" + j.toString()] == "0") {
        var person_id = j.toString();
      } else {
        var person_id = block["id_" + j.toString()];
      }
      try {
        if (typeof block["candidates"][j]["facebook_url"] == "undefined" || block["candidates"][j]["facebook_url"] == "0") {
          document.getElementById("see_more_facebook_link_" + person_id).innerHTML = "";
        }
      } catch (error) {}
      try {
        if (typeof block["candidates"][j]["std_linkedin_url"] == "undefined" || block["candidates"][j]["std_linkedin_url"] == "0") {
          document.getElementById("see_more_linkedin_link_" + person_id).innerHTML = "";
        }
      } catch (error) {}
      try {
        if (typeof block["candidates"][j]["twitter_url"] == "undefined" || block["candidates"][j]["twitter_url"] == "0") {
          document.getElementById("see_more_twitter_link_" + person_id).innerHTML = "";
        }
      } catch (error) {}
      try {
        document.getElementById("see_more_phone_link_" + person_id).innerHTML = "";
      } catch (error) {}
      try {
        document.getElementById("see_more_whatsapp_link_" + person_id).innerHTML = "";
      } catch (error) {}
      try {
        document.getElementById("see_more_email_link_" + person_id).innerHTML = "";
      } catch (error) {}
      try {
        document.getElementById("loader_link_" + person_id).innerHTML = "";
      } catch (error) {}
    }

    document.getElementById("see_more_category").innerHTML = new UtilityFunctions().toTitleCase(block["headline"]);

    $(see_more_modal).modal("show");

    // $('[data-toggle="tooltip"]').tooltip({
    //     placement : 'top'
    //     });

    new UtilityFunctions().activateToolTips();
  }

  submitQueryModal() {
    if (sessionStorage["raw_string_query_input"] == "") {
      document.getElementById("query_input_errors").innerHTML = '<span style="color:red">Please enter query</span>';
    } else {
      // $(enter_query_modal).modal('hide');
      new Query().fetchQueryShowResults("raw_string_query_input");
      $(enter_query_modal).modal("hide");
      $(waiting_results_raw_string).modal("show");
    }
  }

  async submitCreateJobModal() {
    if (sessionStorage["job_name"] == "") {
      document.getElementById("job_name_input_errors").innerHTML = '<span style="color:red">Please enter query</span>';
    } else {
      console.log("submitCreateJobModal FUNCTION CALLED");
      var params_obj = updateParamsObj();
      console.log("This is the create new job modal", sessionStorage["job_name"]);
      $(create_new_job_modal).modal("hide");
      console.log("create new job modal closed");

      // $(waiting_results_raw_string).modal('show');
      console.log("waiting results raw string show");
      let requestBody = {
        // params: JSON.parse(params_obj),
        job_name: sessionStorage["job_name"],
      };

      try {
        const response = await AjaxAPICall(eUrl.createNewJob, eMethod.post, requestBody);
        if (typeof response == "object") {
          var table_obj = {};
          table_obj["table_id"] = response["job_id"];
          table_obj["table_name"] = response["job_name"];
          sessionStorage["current_table"] = JSON.stringify(table_obj);
          sessionStorage["current_sublists"] = JSON.stringify(response["sublists"]);
          console.log("Setting all  sessionStorage jobs here:::", response["jobs"]);
          sessionStorage["all_jobs"] = JSON.stringify(response["jobs"]);
          $(waiting_results_raw_string).modal("hide");
          new PageContents().changePage("/lists");
          $(waiting_results_raw_string).modal("hide");
        } else {
          $(waiting_results_raw_string).modal("hide");
          new PageContents().changePage("/login");
        }
      } catch (error) {
        console.log(error);
      }

      $(waiting_results_raw_string).modal("hide");
    }
  }

  enterQuery() {
    $(enter_query_modal).modal("show");
  }

  cancelUserAccount() {
    console.log("cancelUserAccount FUNCTION CALLED");
    $(confirm_delete_user_account_modal).modal("show");
  }

  generateAPIKey() {
    console.log("generateAPIKey FUNCTION CALLED");

    console.log("generateAPIKey FUNCTION CALLED");
    $.ajax({
      url: "/generate_api_key",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        params: params_obj,
        new_credit_balance: sessionStorage["new_credit_balance"],
        new_plan: sessionStorage["new_plan"],
      },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      document.getElementById("auth_token_input").value = data;
      document.getElementById("auth_token_input").innerHTML = data;
      console.log("This is the API KEY", data);
    });
  }

  tweakPlanAndCreditsModal() {
    console.log("tweakPlanAndCreditsModal FUNCTION CALLED");
    $(tweak_plan_and_credits_modal).modal("show");

    sessionStorage["new_credit_balance"] = 0;
    sessionStorage["new_plan"] = "";
    document.getElementById("tweak_plan_modal_inside_container").innerHTML = document.getElementById("tweak_plan_modal_inside_element").innerHTML;
  }

  applyChangesPlansAndCredits() {
    console.log("applyChangesPlansAndCredits FUNCTION CALLED");
    $.ajax({
      url: "/manually_change_plan_and_credits",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        params: params_obj,
        new_credit_balance: sessionStorage["new_credit_balance"],
        new_plan: sessionStorage["new_plan"],
      },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      console.log("AJAX to hit manually_change_plan_credits ");
      console.log("This is the AJAX response ", data);
      localStorage["user"] = JSON.stringify(data["user"]);
      $(tweak_plan_and_credits_modal).modal("hide");
    });
  }

  openShareModal() {
    console.log("openShareModal FUNCTION CALLED");
    $("#share_link").val(window.location["href"]);
    $(share_modal).modal("show");
  }

  inviteFriend() {
    console.log("inviteFriend FUNCTION CALLED");
    $("#invite_link").val(base_url + "/invite/" + localStorage["user_id"]);
    $(referral_modal).modal("show");
    var params_obj = updateParamsObj();
    $.ajax({
      url: "/load_users_invited",
      type: "POST",
      start_time: new Date().getTime(),
      data: { user_id: localStorage["user_id"] },
      error: function (xhr, status) {
        let error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        if (error_status == 429) {
          console.log("Too Many Requests");
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          new ProcessNodesStates().resetSessionStorageforDropdowns();
        }
        if (error_status == 500) {
          console.log("There has been an error in the load users invited API");
          // window.location.href = '/'
        }
        // alert(xhr.status);
      },
    }).done(function (data) {
      console.log("AJAX to hit load_users_invited ");
      console.log("This is the AJAX response ", data);
      rows = "";
      for (var i = 0, len = data["emails"].length; i < len; i++) {
        rows = rows + "<br> - " + data["emails"][i];
      }
      if (rows != "") {
        rows = "<strong>Users you invited:</strong><br>" + rows;
      }
      document.getElementById("users_invited").innerHTML = rows;
    });
  }

  addFriendsToInviteAndStart() {
    console.log("addFriendsToInviteAndStart FUNCTION CALLED");
    new UtilityFunctions().addPromptEnumListTag();
    $.ajax({
      url: "/add_emails_referred",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        prompt_enum_textarea: sessionStorage["prompt_enum_list"],
      },
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
      },
    }).done(function (data) {
      console.log("AJAX to hit add_emails_referred ");
      console.log("This is the AJAX response ", data);
    });
    // new PageContents().changePage("/org-chart");
    new PageContents().changePage("/lists");
  }

  seeActivity() {
    console.log("seeActivity FUNCTION CALLED");
    var params_obj = updateParamsObj();
    $(activity_modal).modal("show");
    var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/>';
    document.getElementById("activity_container").innerHTML = loader;
    $.ajax({
      url: "/load_user_activity",
      type: "POST",
      start_time: new Date().getTime(),
      data: { user_id: localStorage["user_id"], params: params_obj },
      error: function (xhr, status) {
        let error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        if (error_status == 429) {
          console.log("Too Many Requests");
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          new ProcessNodesStates().resetSessionStorageforDropdowns();
        }
        if (error_status == 500) {
          console.log("There has been an error in the laod user activity api");
        }
      },
    }).done(function (data) {
      console.log("AJAX to hit load_user_activity");
      console.log("This is the AJAX response ", data);

      var rows = "";
      for (var i = 0, len = data["activity"].length; i < len; i++) {
        try {
          var company_id = data["activity"][i]["company_id"][0]["name"];
          var current_focus = data["activity"][i]["current_focus"];
          var std_function = data["activity"][i]["std_function"][0]["name"];
          var std_grade = data["activity"][i]["std_grade"][0]["name"];
        } catch {
          var company_id = data["activity"][i]["company_id"][0]["name"];
          var current_focus = data["activity"][i]["current_focus"];
          var std_function = "";
          var std_grade = "";
        }
        var activity_description = "Built " + company_id + " " + current_focus + " for function: " + std_function + " and level: " + std_grade;
        // activity_description = 'Built ' + company_id + ' ' + data['activity'][i]['current_focus'] + ' for function: '+  data['activity'][i]['std_function'][0] +' and level:'+ data['activity'][i]['std_grade'][0]  +' using ' + data['activity'][i]['data_source']
        if (data["activity"][i]["query_status"] == "complete") {
          var dot_color = "blue_dot";
        }
        if (data["activity"][i]["query_status"] == "success") {
          var dot_color = "blue_dot";
        } else if (data["activity"][i]["query_status"] == "incomplete") {
          var dot_color = "orange_dot";
        } else if (data["activity"][i]["query_status"] == "starting") {
          var dot_color = "red_dot";
        } else {
          var dot_color = "orange_dot";
        }
        var request_id = data["activity"][i]["request_id"];
        rows =
          rows +
          document
            .getElementById("activity_row_element")
            .innerHTML.replace(/{date}/g, data["activity"][i]["request_time"].slice(5, 12))
            // .replace(/{date}/g, data['activity'][i]['request_time'])
            .replace(/{activity_description}/g, activity_description)
            .replace(/{dot_color}/g, dot_color)
            .replace(/{request_id}/g, request_id);
      }
      document.getElementById("activity_container").innerHTML = rows;
      sessionStorage["activity"] = JSON.stringify(data);
    });
    // try{
    //     document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("start_search_element").innerHTML
    //     document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("start_search_element").innerHTML
    // }
    // catch (error){console.log("Error:",error)}
  }

  openBooleanKeywordsModal(boolean_keywords_string) {
    console.log("openShareModal FUNCTION CALLED");
    // $("#share_link").val(boolean_keywords_string)
    document.getElementById("boolean_keywords_modal_textarea").innerHTML = boolean_keywords_string;
    $(boolean_keywords_modal).modal("show");
  }

  openJobDeleteModal() {
    $(confirm_delete_job_modal).modal("show");
  }

  confirmDeleteJob(user_input) {
    console.log("Delete job clicked");
    $(confirm_delete_job_modal).modal("hide");
    console.log("This is user input::", user_input);
    var table_to_delete = null;
    if (user_input) {
      table_to_delete = user_input.getAttribute("table_id");
    }
    if (!table_to_delete) {
      table_to_delete = JSON.parse(sessionStorage["current_table"])["table_id"];
    }
    console.log("Table to delete:", table_to_delete);

    var params_obj = updateParamsObj();
    // console.log("Table to delete:", table_to_delete)
    $.ajax({
      url: "/delete_job",
      type: "POST",
      data: {
        user_id: localStorage["user_id"],
        params: params_obj,
        visitor_fp: sessionStorage["visitor_fp"],
        table_id: table_to_delete,
      },
      error: function (xhr, status) {
        let error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        if (error_status == 429) {
          console.log("Too Many Requests");
          document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          // Not trying to reset session storage if there's an error
          // new ProcessNodesStates().resetSessionStorageforDropdowns()
        }
        if (error_status == 500) {
          console.log("There has been an error in the autocomplete query");
          // window.location.href = '/'
        }
        // alert(xhr.status);
      },
    }).done(function (data) {
      console.log("AJAX to hit ", data);
      // console.log(data);
      // data = JSON.parse(data)
      // debugger;
      if (data?.status == "fail") {
        document.getElementById("general_message_title").innerText = "Delete Job";
        document.getElementById("general_message_text").innerText = "something went wrong!, Please try again after some time or contact us";
        $(general_message_modal).modal("show");
      } else {
        var all_jobs = data["all_jobs_arr"];
        console.log("Setting all sessionStorage jobs here:::", all_jobs);
        sessionStorage["all_jobs"] = JSON.stringify(all_jobs);
        var all_jobs_rows = "";
        while (all_jobs.length) {
          var single_jobs_row = all_jobs.splice(0, 4);
          var single_jobs_row_html = "";
          for (var single_job in single_jobs_row) {
            var single_jobs_row_html =
              single_jobs_row_html +
              document
                .getElementById("job_card_element")
                .innerHTML.replaceAll("{job_id}", single_jobs_row[single_job]["job_id"])
                .replaceAll("{job_name}", single_jobs_row[single_job]["job_name"])
                .replaceAll("{start_date}", single_jobs_row[single_job]["start_date"]);
          }
          var all_jobs_rows = all_jobs_rows + '<div style="display:table; width:100%">' + single_jobs_row_html + "</div><br><br>";
        }
        new PageContents().changePage("/lists");

        var all_jobs_listing = '<div style="text-align:center; width:90%;margin: auto;left:0;right: 0; margin-top:3%">' + all_jobs_rows + "</div>";
        document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = all_jobs_listing;
        document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = all_jobs_listing;
      }
    });
  }
  // editJDJob(element){
  //     console.log("edit JD job clicked")
  //     console.log("This is user input::")
  //     console.log("JD to edit:", element)
  //     var job_id = element.getAttribute('table_id');
  //     // var params_obj = updateParamsObj();
  //     let data_obj = JSON.stringify({
  //         user_id: localStorage["user_id"],
  //         visitor_fp: sessionStorage["visitor_fp"],
  //         job_id: job_id,
  //     })
  //     sessionStorage['edit_jd_company_token'] = JSON.stringify([])
  //     sessionStorage['edit_jd_location_token'] = JSON.stringify([])
  //     $.ajax({
  //         url: "/get_jd_details",
  //         type: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         data: data_obj,
  //         error: function (xhr, status) {
  //             let error_status = xhr.status;
  //             if (error_status == 500) {
  //                 console.log("There has been an error in the autocomplete query");
  //                 // window.location.href = '/'
  //             }
  //             // alert(xhr.status);
  //         },
  //     }).done(function (data) {
  //         console.log("AJAX to hit for edit_jd ");
  //         console.log("This is the AJAX response ", data);
  //         let editJdDetails = data.data
  //         let data_to_store ={
  //             "job_name":editJdDetails["job_name"],
  //             "job_id":editJdDetails["job_id"],
  //             "gpt_reponse_obj":editJdDetails["gpt_reponse_obj"],
  //             "client_query_obj":editJdDetails["client_query_obj"]
  //         }
  //         console.log(data_to_store);
  //         sessionStorage['editJdDetails'] = JSON.stringify(data_to_store)

  //         let headline = document.getElementById('headline_modal_edit_jd')

  //         headline.innerHTML = `<h5><strong>Edit JD : ${data_to_store.job_name || ''}</strong></h5>`

  //         document.getElementById('edit_jd_company_search_gpt').value=''

  //         let master_container_function_root = document.getElementById('modal_edit_jd_function_root_master')
  //         master_container_function_root.innerHTML = new EditJDComponents().generateHTMLForFunctionRoot('edit_jd_function_root')

  //         let sub_function_root = document.getElementById("modal_edit_jd_sub_function_master")
  //         sub_function_root.innerHTML = new EditJDComponents().generateHTMLForSubFunction('edit_jd_sub_function','')

  //         // let edit_jd_location_country = document.getElementById("modal_edit_jd_location_country_master")
  //         // edit_jd_location_country.innerHTML = new EditJDComponents().generateHTMLForCountry('edit_jd_country','')

  //         document.getElementById("btn_edit_jd_grades").innerText = 'Seniorty';

  //        if(data_to_store?.client_query_obj.lenght > 0 || typeof data_to_store?.client_query_obj == 'object' ){
  //             if(editJdDetails.client_query_obj.function_root.length > 0){
  //                 document.getElementById('btn_edit_jd_function_root').innerText = editJdDetails.client_query_obj.function_root[0].name
  //             }
  //             if(editJdDetails.client_query_obj.functions.length > 0){
  //                 document.getElementById('btn_edit_jd_sub_function').innerText = editJdDetails.client_query_obj.functions[0].name
  //             }
  //             if(editJdDetails.client_query_obj.grades.length > 0){
  //                 document.getElementById('btn_edit_jd_grades').innerText = editJdDetails.client_query_obj.grades[0].name
  //             }
  //             // if(editJdDetails.client_query_obj.country.length > 0){
  //             //     document.getElementById('btn_edit_jd_country').innerText = editJdDetails.client_query_obj.country[0].name
  //             // }
  //             // if(editJdDetails.client_query_obj.region.length > 0){
  //             //     document.getElementById('btn_edit_jd_region').innerText = editJdDetails.client_query_obj.region[0].name
  //             // }
  //             // if(editJdDetails.client_query_obj.locality.length > 0){
  //             //     document.getElementById('btn_edit_jd_locality').innerText = editJdDetails.client_query_obj.locality[0].name
  //             // }
  //        }

  //         $(edit_uploaded_jd).modal("show");

  //     });
  // }
  onClickEditJob(element) {
    console.log("edit JD job clicked");
    console.log("JD to edit:", element);
    var job_id = element.getAttribute("table_id");
    var job_name = element.getAttribute("job_name");

    let jobs = JSON.parse(sessionStorage["all_jobs_details"]);
    let current_job = jobs.find((job) => job.job_id == job_id);

    if (current_job.hasOwnProperty("client_query_obj")) {
      if (Array.isArray(current_job.client_query_obj) && current_job.client_query_obj.length > 0) {
        sessionStorage["current_job"] = JSON.stringify(current_job);
        new EditJDComponents().onLoadEditJdModal(current_job);
        $(edit_uploaded_jd).modal("show");
      }
      if (typeof current_job.client_query_obj === "object" && current_job.client_query_obj.hasOwnProperty("active_experience")) {
        sessionStorage["current_job"] = JSON.stringify(current_job);
        new EditJDComponents().onLoadEditJdModal(current_job);
        $(edit_uploaded_jd).modal("show");
      } else {
        let data = { job_id, job_name };
        console.log("current_job::", data);
        sessionStorage["current_job"] = JSON.stringify(data);
        new UploadJDCVTopBar().uploadJD();
      }
    } else {
      let data = { job_id, job_name };
      console.log("current_job::", data);
      sessionStorage["current_job"] = JSON.stringify(data);
      new UploadJDCVTopBar().uploadJD();
    }
  }
  updateJDJob(update_type) {
    var loader = document.getElementById("modal_edit_jd_error");
    loader.innerHTML = '<div style="width:100%;text-align:center; padding:10px"><img style="width:30px" src="/static/img/new_loading2.gif"/></div>';
    let currentJobObj = sessionStorage["current_job"];

    let data_obj = JSON.stringify({
      user_id: localStorage["user_id"],
      visitor_fp: sessionStorage["visitor_fp"],
      job_obj: currentJobObj,
    });
    let url = "";
    if (update_type == "get_candidate") {
      url = "/update_jd_get_candidate";
    } else {
      url = "/update_jd_save";
    }
    $.ajax({
      url: url,
      type: "POST",
      headers: { "Content-Type": "application/json" },
      data: data_obj,
      error: function (xhr, status) {
        let error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        if (error_status == 500) {
          loader.innerHTML = "Something went wrong!, Please try again after sometime";
          console.log("There has been an error in the autocomplete query");
          $(edit_uploaded_jd).modal("hide");
          // window.location.href = '/'
        }
        // alert(xhr.status);
      },
    }).done(function (data) {
      console.log("AJAX to hit for edit_jd ");
      console.log("This is the AJAX response ", data);
      if (data?.status == "success" && url != "/update_jd_save") {
        $(edit_uploaded_jd).modal("hide");
        loader.innerHTML = "";
        new Toggle().setHeadlineLeftPanelUnderLineTabs("lists");
        var job_id_selected = data.data.job_obj.table_id;
        var job_name_selected = data.data.job_obj.table_name;
        console.log("This is the table selected:::", job_id_selected);
        console.log("Setting current table here:::");
        sessionStorage["current_table"] = JSON.stringify({
          table_id: job_id_selected,
          table_name: job_name_selected,
        });
        new PageContents().changePage("/tables");
        document.getElementById("general_message_title").innerText = "Edit Jd : " + job_name_selected;
        document.getElementById("general_message_text").innerText = "we will processing your request and get candidate based on that, It will take few minutes, please refresh job after sometime";
        $(general_message_modal).modal("show");
      } else {
        $(edit_uploaded_jd).modal("hide");
        loader.innerHTML = "";
        console.log("JD save without fetch candidate");
      }
    });
  }
}

// handles the popstate events, i.e. when a user click on the "back" button on the browser
$(window).on("popstate", function (e) {
  console.log("popstate FUNCTION CALLED");
  new UtilityFunctions().pageBack();
});


export { PageContents, Modals };
if (typeof window !== 'undefined') {
  window.PageContents = PageContents;
  window.Modals = Modals;
}
